module.exports = __webpack_public_path__ + "img/39.129bb536.jpg";